import { UploadFile, CheckCircleOutline } from '@lichtblick/icons';
import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const UploadFileIcon = styled(UploadFile)`
  color: ${Colors.blue['20']};
  height: 3rem;
  width: 3rem;
`;

export const CheckIcon = styled(CheckCircleOutline)<{ $isSuccess: boolean }>`
  color: ${({ $isSuccess }) => ($isSuccess ? Colors.green['100'] : Colors.gray['20'])};
`;

export const MainContent = styled.div`
  align-items: center;
  background-color: ${Colors.blue['5']};
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
  max-width: 40rem;
  padding: ${Spacing.Xs};
  width: 30rem;

  @media (max-width: 600px) {
    max-width: none;
    padding: ${Spacing.Xs};
    width: 100%;
  }
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
  max-width: 100%;
  overflow-x: hidden;
  padding: ${Spacing.Xs};
  width: 30rem;

  @media (max-width: 600px) {
    gap: ${Spacing.Xs};
    padding: ${Spacing.Xs};
    width: 100%;
  }
`;

export const FileContainer = styled.div`
  align-items: center;
  border: 1px solid ${Colors.blue['20']};
  border-radius: ${Spacing['3Xs']};
  display: flex;
  gap: ${Spacing.Xs};
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  padding: ${Spacing.Xxs};
  width: 100%;

  @media (max-width: 600px) {
    gap: ${Spacing.Xs};
    padding: ${Spacing.Xxs};
  }
`;
export const FlexColumn = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  gap: ${Spacing['4Xs']};
  min-width: 0;
  overflow: hidden;

  @media (max-width: 600px) {
    gap: ${Spacing['3Xs']};
  }
`;
